<template src="../templates/tzoSearch.html" />

<script setup>

import {
    AisInstantSearch,
    AisSearchBox,
    AisHits,
    AisPagination,
    AisMenu,
    AisConfigure,
    AisClearRefinements,
    AisStats,
} from 'vue-instantsearch/vue3/es';

import { searchParameters, hitsPerPage } from '../config/config';

/*
    If we don't do this, then the chosen facet
    hops to the top of the <ais-menu> option list
*/
/* eslint-disable func-names */
function alphabetiseFacets(items) {

    /* eslint-disable-next-line */
    return items.sort(function (a, b) {

        if (a.label < b.label) {

            return -1;

        }
        if (a.label > b.label) {

            return 1;

        }
        return 0;

    });

}

function scrollToTop() {

    document.getElementById('tzo-search-app').scrollIntoView();

}

</script>
